import { actions } from '../../actions/actionTypes'

const initialState = {
  uploadSuccess: null,
  uploadStatusCode: null,
  uploadResponseData: null
}

const upload = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_UPLOAD_STATE:
      return {
        ...state,
        uploadSuccess: action.payload.success,
        uploadStatusCode: action.payload.statusCode,
        uploadResponseData: action.payload.responseData,
      }
    default:
      return state
  }
}

export default upload
